import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";

export const winnerListingApi = createAsyncThunk(
  "auth/winnerListing",
  async (data, { rejectWithValue }) => {
    try {
      const winner = await AuthAxios.get(
        apiRoutes.competitionAction(`top-10/${data.id}/`),
        { params: data }
      );
      return winner?.data;
    } catch (error) {
      return rejectWithValue(error?.winner?.data);
    }
  }
);
const initialState = { result: [], loading: false, error: null, message: "", total: 0 }

const winnerListingSlice = createSlice({
  name: "winnerListing",
  initialState,
  reducers: {
    resetwinnerListing: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(winnerListingApi.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(winnerListingApi.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.result;
      state.message = action?.payload?.message;
      state.total = action?.payload?.count
    });
    builder.addCase(winnerListingApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});
export const { resetwinnerListing } = winnerListingSlice.actions;
export const winnerListingreducer = winnerListingSlice.reducer;
